import React from 'react';
import { Box, useTheme } from '@mui/material';

const ICON_DARK = '/static/assets/beamOnScreen/BeamOnScreenDarkTheme.svg';
const ICON_LIGHT = '/static/assets/beamOnScreen/BeamOnScreenLightTheme.svg';

/** Theme-aware Beam on Screen brand mark for the sidebar accordion header. */
export const BeamOnScreenSidebarIcon: React.FC = () => {
  const theme = useTheme();
  const src = theme.palette.mode === 'dark' ? ICON_DARK : ICON_LIGHT;

  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        flexShrink: 0,
        position: 'relative',
        overflow: 'visible',
      }}
    >
      <Box
        component="img"
        src={src}
        alt=""
        aria-hidden
        sx={{
          width: 36,
          height: 36,
          display: 'block',
          objectFit: 'contain',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </Box>
  );
};

export default BeamOnScreenSidebarIcon;
